module.exports = __webpack_public_path__ + "static/scribble-thumb-6e9fd3db1c27dfacd93dd7141bbaeedf.png";